export const ABNORMAL_STATE = {
  OK: 'OK',
  ABNORMAL: 'ABNORMAL',
  CHECKED: 'CHECKED'
} as const

export const ABNORMAL_STATE_TITLE = {
  [ABNORMAL_STATE.OK]: 'Непроверенный',
  [ABNORMAL_STATE.ABNORMAL]: 'Аномальный',
  [ABNORMAL_STATE.CHECKED]: 'Верный'
}
